import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { memo, useCallback } from "react";
import { equals, pick } from "ramda";
import { MessageExpander } from "@interdependence-ui";
import SelectOrganizations from "./SelectOrganizations";
import { removeUnitsFromSelectedList, useUnitListsContext, addUnitsToSelectedList } from "@unitLists";
import { extendedSystemStylesProps } from "@mixins";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var styledSystemKeys = ["space", "layout", "flexbox"];
export default /*#__PURE__*/memo(function SelectUnitListOrganizations(props) {
  var selected = props.selected,
    reportingUnits = props.reportingUnits,
    limit = props.limit;
  var _useUnitListsContext = useUnitListsContext(),
    setUnitLists = _useUnitListsContext.setUnitLists;
  var disabled = selected.length === limit;
  var handleSelect = useCallback(function (add, id) {
    return setUnitLists(function (old) {
      return add ? addUnitsToSelectedList(old, [id]) : removeUnitsFromSelectedList(old, [id]);
    });
  }, [setUnitLists]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SelectOrganizations, _objectSpread({
      id: "unitlist",
      onChange: handleSelect,
      selected: selected,
      disabledOption: function disabledOption(id) {
        return reportingUnits && !reportingUnits.includes(id);
      },
      disabled: disabled
    }, extendedSystemStylesProps(styledSystemKeys, props))), /*#__PURE__*/_jsx(MessageExpander, {
      id: "units-length-limit-error",
      open: disabled,
      type: "error",
      m: "10px 0 -10px",
      message: "Du kan inte l\xE4gga till fler enheter, din lista inneh\xE5ller max antal enheter."
    })]
  });
}, function (prev, curr) {
  return equals(pick(["selected", "reportingUnits", "limit"], prev), pick(["selected", "reportingUnits", "limit"], curr));
});